import { c as _c } from "react/compiler-runtime";
import { SwipeableDrawer } from "@mui/material";
const BottomSheet = t0 => {
  const $ = _c(16);
  const {
    open,
    onClose,
    onOpen,
    children,
    bgColor,
    maxWidth
  } = t0;
  let t1;
  if ($[0] !== onOpen) {
    t1 = () => {
      onOpen?.();
    };
    $[0] = onOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpen = t1;
  let t2;
  if ($[2] !== onClose) {
    t2 = () => {
      onClose?.();
    };
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleClose = t2;
  const t3 = bgColor || "white";
  const t4 = maxWidth || "100%";
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      sx: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        overflow: "hidden",
        backgroundColor: t3,
        maxWidth: t4,
        margin: "0 auto"
      }
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-8 h-[4px] rounded-[--radius100] my-4 bg-[--colorOutlineOutlineVar] mx-auto" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children) {
    t7 = <div>{children}</div>;
    $[8] = children;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleClose || $[11] !== handleOpen || $[12] !== open || $[13] !== t5 || $[14] !== t7) {
    t8 = <SwipeableDrawer anchor="bottom" open={open} onOpen={handleOpen} onClose={handleClose} PaperProps={t5}>{t6}{t7}</SwipeableDrawer>;
    $[10] = handleClose;
    $[11] = handleOpen;
    $[12] = open;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default BottomSheet;